import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../utils';
export function TableCell({ children, className, style, to, isFirstCell = false, as: LinkComponent, }) {
    return (_jsxs("td", { className: cn('px-stack-roomy h-14 relative', className), style: style, children: [children, to && (LinkComponent ? (_jsx(LinkComponent, { to: to, tabIndex: isFirstCell ? 0 : -1, className: "absolute inset-0" })) : (_jsx("a", { href: to, tabIndex: isFirstCell ? 0 : -1, className: "absolute inset-0" })))] }));
}
